export default {
  title: 'Zubereitungszeit',
  form: {
    has_busy_mode: {
      label: 'Beschäftigt-Modus',
    },
    busy_mode_minutes: {
      label: 'Wie viel Zeit zur normalen Zubereitungszeit hinzufügen?',
      options: {
        10: '10 min',
        15: '15 min',
        20: '20 min',
        25: '25 min',
        30: '30 min',
        45: '45 min',
        60: '1 Stunde',
      },
    },
  },
  buttons: {
    save: 'Speichern',
  },
  toasts: {
    failed_to_save_changes: 'Änderungen konnten nicht gespeichert werden',
    changes_got_saved: 'Änderungen erfolgreich gespeichert',
  },
};
